import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessagesService } from '@boxx/messages-core';
import { NotificationModel } from '@boxx/messages-core/lib/models/Notification.model';
import { Capacitor } from '@capacitor/core';
import { ActionSheetController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoxxUtilsService } from './BoxxUtils.service';
import { Browser } from '@capacitor/browser';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';

@Injectable()
export class NotificationsService {
  private isIos = false;
  private isApp: boolean;
  translations: any;
  destroyed$ = new Subject<boolean>();

  constructor(
    private plt: Platform,
    private router: Router,
    private messageSrv: MessagesService,
    private boxxUtils: BoxxUtilsService,
    private actionSheetCtrl: ActionSheetController,
    private translateService: TranslateService,
    private socialShar: SocialSharing
  ) {
    this.plt.ready().then(() => {
      this.isApp = document.URL.indexOf('http') !== 0;
      this.isIos = this.plt
        .platforms()
        .some((name) => ['ios', 'ipad', 'iphone'].includes(name));
    });

    this.translateService
      .get(['NOTIFICATIONS', 'ACTIONS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t) => {
        this.translations = t;
      });
  }

  openPush(message: NotificationModel) : void {
    console.log('message: ', message);
    switch (message.type) {
      case 'gmbreview':
          this.boxxUtils.handleLoading(true);
          this.messageSrv
          .getReviewLink()
          .subscribe((link: string) => {
            this.boxxUtils.handleLoading(false);
            if (Capacitor.isNativePlatform()) {
              const msgReview = 'Hola ' + message.data.name + ' nos encantaría poder escuchar de ti en nuestro perfil de Google mi negocio.';
              this.socialSharing({message: msgReview, subject: "Tu opinión es importante", url: link}); 
            }
            else{
              this.requestPWA(message.data.email, message.data.name, message.data.phone, link); 
            }     
          });
        break;
      
      case 'inboxx':
      case 'contact':
      case 'event':
      case 'store':
      case 'gmb':
      case 'message':
        if(message.data.target === 'tasks'){
          this.router.navigateByUrl('tasks');
        }
        else if(message.data.target === 'store'){
          this.router.navigateByUrl('/tabs/store/orders');
        }
        else{
          this.router.navigateByUrl(message.data.target);
        }

      break;

      default:
        break;
    }
  }

  async requestPWA(email: string, name: string, phone: number, link: string) : Promise<void> {
      const buttons = [];
      if(email !== null){
        buttons.push(
          {
            text: this.translations.NOTIFICATIONS.REVIEW.emailText,
            handler: () => {
              this.openEmail(email, name, link);
            },
            icon: 'mail-outline'
          },
        );
      }
      if(phone !== null){
        buttons.push(
          {
            text: this.translations.NOTIFICATIONS.REVIEW.whatsText,
            handler: () => {
              const msgReview = 'Hola%20' + name + '%20nos%20encantaría%20poder%20escuchar%20de%20ti%20en%20nuestro%20perfil%20de%20Google%20mi%20negocio:%20' + link;
              this.openExternalURL('https://wa.me/+52' + phone + '?text='+msgReview);
            },
            icon: 'logo-whatsapp'
          }
        );
      }
        (
          await this.actionSheetCtrl.create({
          header: this.translations.NOTIFICATIONS.REVIEW.header_Alert,
          buttons: [
            ...buttons,
            {
              text: this.translations.ACTIONS.cancel,
              role: 'cancel',
              icon: 'close-circle-outline'
            },
          ],
        })
        ).present();
  }

  openEmail(mail: string, name: string, link: string) : void {
    const deviceInfo = {
      manufacturer: '',
      model: '',
      osName: '',
      version: '',
    };

    deviceInfo.model = window.navigator.userAgent;

    const addNewLine = (text: string) => {
      const BLACK_LIST = ['ELE-L29', 'LG-H500'];
      const newLine =
        BLACK_LIST.indexOf(deviceInfo.model.toUpperCase()) !== -1 ? '</br>' : '\n';
      return encodeURIComponent(`${newLine}${text}`);
    };

    const subject = `?subject=Tu%20opinión%20es%20importante&body=`;
    const container = `${mail}`;
    const msg = 'Hola! ' + name + ' nos encantaría poder escuchar de ti en nuestro perfil de Google mi negocio:';
    const separator = addNewLine('');
    const urlReview = addNewLine(link);


    let body = '';

    body = msg + separator + urlReview + separator;

    const url = container + subject + body;
    window.open('mailto:'+url, '_blank');
  }

  async openURL(url: string) : Promise<void> {
    await Browser.open({ url: url, toolbarColor: 'primary', presentationStyle: 'fullscreen' });
  }

  async openExternalURL(url: string) : Promise<void>  {
    //window.open(url, '_system');
    await Browser.open({ url });
  }

  async socialSharing(options: ISharingOptions) : Promise<void>  {
    try {
      this.socialShar.share(options.subject? options.message : 'Compartir', 'Compartir', options.message, '')
        .then(() => {}).catch((error) => {});
        
      // await Share.share({
      //   title: options.subject? options.message : 'Compartir',
      //   text: options.message,
      //   dialogTitle: 'Compartir',
      // });
    } catch (error) {}
  }
  
}

interface ISharingOptions {
  message?: string;
  subject?: string;
  files?: string | string[];
  url?: string;
  chooserTitle?: string;
}
